import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MoveDiagonal = createReactComponent("MoveDiagonal", ["svg", defaultAttributes, [["polyline", {
  points: "13 5 19 5 19 11",
  key: "1v5ik2"
}], ["polyline", {
  points: "11 19 5 19 5 13",
  key: "1evf3t"
}], ["line", {
  x1: "19",
  y1: "5",
  x2: "5",
  y2: "19",
  key: "18lstb"
}]]]);
export default MoveDiagonal;